import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom';
import * as paths from '@/routes/paths';

// page_viewイベントを送信するためのパス一覧
const pagePaths = [
  paths.reservation,
  paths.driveList,
  paths.driveDetails,
  paths.menu,
  paths.notification,
  paths.vehicleDriverUpdate,
  paths.vehicleDriverSelect,
  paths.operationFinishConfirm,
  paths.offering,
  paths.waypointConfirm,
  paths.driveRoutes,
] as const;

type PathValue = (typeof pagePaths)[number];

const isPage = (pathname: string): pathname is PathValue => pagePaths.some((pagePath) => pagePath === pathname);

// 先頭の/を削除したパスをタイトルとする
const getPageTitle = (pathName: PathValue): string => pathName.replace('/', '');

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isPage(location.pathname)) {
      return;
    }
    const path = location.pathname;

    // virtual_page_viewイベントをGTMタグでpage_viewイベントにマッピングすることでGA4でpage_viewイベントとして認識される
    TagManager.dataLayer({
      dataLayer: {
        event: 'virtual_page_view', // GTMトリガーで設定するイベント名
        page: {
          // GTMタグでpage_pathとpage_titleにマッピングすることでGA4のページパスとページタイトルとして認識される
          path,
          title: getPageTitle(path),
        },
        siteSegment: 'driver', // GTMタグでsite_segmentにマッピング
      },
    });
  }, [location.pathname]);
};
